import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#102781", // Example primary color
    },
    secondary: {
      main: "#19857b", // Example secondary color
    },
    error: {
      main: "#red", // Example error color
    },
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    h2: {
      fontSize: "2.5rem",
      fontWeight: 700,
      marginBottom: "1rem",
      textAlign: "center", // Center headings
    },
    h3: {
      fontSize: "1.8rem",
      fontWeight: 600,
      marginBottom: "0.5rem",
    },
    h4: {
      fontSize: "1.5rem",
      fontWeight: 500,
    },
    h5: {
      fontSize: "1.2rem",
      fontWeight: 500,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.6,
    },
    body2: {
      fontSize: "0.9rem",
      lineHeight: 1.5,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8, // Example button style
        },
      },
    },
  },
});

export default theme;
